import {
  CONNECTION_REQUEST,
  CONNECTION_SUCCESS,
  CONNECTION_FAILED,
  UPDATE_ACCOUNT,
} from "./actionTypes"

// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3Modal from "web3modal";

// log
import { fetchData } from "../data/actions";

export const  connectRequest = () => {
  return {
    type: CONNECTION_REQUEST,
  };
};

export const  connectSuccess = (payload) => {
  return {
    type: CONNECTION_SUCCESS,
    payload: payload,
  };
};

export const  connectFailed = (payload) => {
  return {
    type:CONNECTION_FAILED,
    payload: payload,
  };
};

export const  updateAccountRequest = (payload) => {
  return {
    type:UPDATE_ACCOUNT,
    payload: payload,
  };
};


export const connectData = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    const abiResponse = await fetch("/config/abi.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const abi = await abiResponse.json();
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const CONFIG = await configResponse.json();
    // const { ethereum } = window;
    // const metamaskIsInstalled = ethereum && ethereum.isMetaMask;
    // if (metamaskIsInstalled) {
    // Web3EthContract.setProvider(ethereum);
    // let web3 = new Web3(ethereum);

    try {
      const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider, // required
          options: {
            infuraId: "91c105a5db5a40cdb0099212ba17cb5f", // required
          },
        },
      };

      const web3Modal = new Web3Modal({
        providerOptions,
        cacheProvider: false,
      });

      const provider = await web3Modal.connect();

      // Add listeners start
      provider.on("accountsChanged", (accounts) => {
        dispatch(updateAccount(accounts[0]));
      });
      // provider.on("chainChanged", () => {
      //   window.location.reload();
      // });

      Web3EthContract.setProvider(provider);
      let web3 = new Web3(provider);

      // const accounts = await ethereum.request({
      //   method: "eth_requestAccounts",
      // });
      // const networkId = await ethereum.request({
      //   method: "net_version",
      // });

      let account = await web3.eth.getCoinbase();
      if (!account) {
        await provider.request({ method: "eth_requestAccounts" });
        account = await web3.eth.getCoinbase();
      }

      const chainId = await web3.eth.getChainId();

      if (chainId !== CONFIG.NETWORK.ID) {
        try {
          await provider.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: "0x89" }],
          });
        } catch (err) {
          // if no chain found request to add
          if (err.code === 4902 || /Unrecognized chain ID/.test(err.message))
            await provider.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x89",
                  chainName: "Matic",
                  nativeCurrency: {
                    name: "Matic",
                    symbol: "Matic",
                    decimals: 18,
                  },
                  rpcUrls: ["https://polygon-rpc.com/"],
                  blockExplorerUrls: ["https://polygonscan.com"],
                },
              ],
            });
          // dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
          else throw err;
        }
      }

      const SmartContractObj = new Web3EthContract(
        abi,
        CONFIG.CONTRACT_ADDRESS
      );
      dispatch(
        connectSuccess({
          account: account,
          smartContract: SmartContractObj,
          web3: web3,
        })
      );
      // Add listeners start
      // ethereum.on("accountsChanged", (accounts) => {
      //   dispatch(updateAccount(accounts[0]));
      // });
      // ethereum.on("chainChanged", () => {
      //   window.location.reload();
      // });
      // Add listeners end
    } catch (err) {
      dispatch(connectFailed(err.message || err));
    }
    // } else {
    // dispatch(connectFailed("Install Metamask."));
    // }
  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};

